import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-border/50 bg-background px-3 py-2 text-sm transition-colors duration-150",
          "ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground", 
          "placeholder:text-muted-foreground/70 hover:border-border focus:border-ring focus:outline-none focus:ring-1 focus:ring-ring",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-border/50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
